import { render, staticRenderFns } from "./agreement-privacy.vue?vue&type=template&id=4ae34347&scoped=true&"
import script from "./agreement-privacy.vue?vue&type=script&lang=js&"
export * from "./agreement-privacy.vue?vue&type=script&lang=js&"
import style0 from "./agreement-privacy.vue?vue&type=style&index=0&id=4ae34347&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ae34347",
  null
  
)

export default component.exports